/**
 * One person's own KRA score out of 100: the sum of weightage x (score / 5)
 * over the items they've scored - i.e. what the total would be if only their
 * scores counted. `scoreOf(item)` returns that person's 0-5 score for an item
 * (or null/undefined if they haven't scored it yet).
 *
 * Returns null when they haven't scored anything, so a card can show a dash
 * instead of a misleading 0.
 *
 * This is deliberately NOT cycle.preview_score / final_score: those blend
 * Self 30% + HOD 50% + External 20% into one number, so showing them under a
 * "Self Score" or "HOD Score" label makes the two look identical.
 */
export const ownScoreOutOf100 = (items, scoreOf) => {
  let total = 0;
  let scored = 0;
  (items || []).forEach((item) => {
    const score = scoreOf(item);
    if (score == null) return;
    total += (Number(item.weightage) * Number(score)) / 5;
    scored += 1;
  });
  return scored ? Math.round(total * 100) / 100 : null;
};
